import { render, staticRenderFns } from "./ViewDestination.vue?vue&type=template&id=8de7bd94&scoped=true"
import script from "./ViewDestination.vue?vue&type=script&lang=js"
export * from "./ViewDestination.vue?vue&type=script&lang=js"
import style0 from "./ViewDestination.vue?vue&type=style&index=0&id=8de7bd94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de7bd94",
  null
  
)

export default component.exports